


















































































import { Component, Prop, Vue } from 'vue-property-decorator';


@Component({})
export default class StoreFilters extends Vue {
  @Prop({ type: String, default: '' })
  public route!: string;
  setSticky: boolean = false;
  singleDropDown: boolean = true;
  storeCategories = [];

  data() {
    return {
      category: this.$route.params.category
    }
  }
  storeCat = this.$store.state.storeCategories;


  switchCategory(category){
    this.$store.dispatch('updateStoreCategories', category);
    this.$router.push({name: 'store-detail-category', params: {category: category.category}});
  }

  switchSubCategory (subCategory) {
    this.$store.dispatch('updateStoreSubCategory', subCategory);
    this.$router.push({name: 'store-detail-subcategory', params: {category: this.$store.state.activeCategory, subCategory: subCategory}});
  }

  switchFilter(filter)  {
    this.$store.dispatch('updateStoreFilter', filter);
    this.$router.push({name: 'store-detail-filter', params: {category: this.$store.state.activeCategory, subCategory: this.$store.state.activeSubCategory, filter: filter}});
  }

  mounted() {
      this.storeCategories.push(
        {
          category: 'swag',
          title: 'Swag'
        },
        {
          category: 'apparel',
          title: 'Apparel'
        },
        {
          category: 'featured',
          title: 'Featured'
        }
      )
  }



}

